import { redirectIfNotAuthenticated, request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";
import { ActiveUser } from "@/services/user";

export const FILES_ENDPOINTS = {
  upload: `${BASE_URL}api/files/upload`,
  datahub_upload: `${BASE_URL}api/datahub_upload/upload`,
  download: `${BASE_URL}api/files/download/`,
  delete: `${BASE_URL}api/files/delete/`,
  list: `${BASE_URL}api/files/list/`,
  availableFileTypes: `${BASE_URL}api/files/available_file_types/`,
};

class Files {
  uploadFile(file, fileId, testMode = null, onProgress = null) {
    return new Promise((resolve, reject) => {
      const uploadedFilename = file.name;
      const formData = new FormData();
      // Files bigger then 4GB aren't supported with current nginx config
      if (file.size > 4000000000) {
        reject("File is too big");
      }
      formData.append("file", file, uploadedFilename);
      formData.append("file_id", fileId);
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          onProgress && onProgress(100);
          if (
            xhr.status === 200 &&
            JSON.parse(xhr.responseText).status !== "FAILED"
          ) {
            resolve(JSON.parse(xhr.responseText));
          } else {
            redirectIfNotAuthenticated(xhr);
            try {
              const response = JSON.parse(xhr.responseText);
              reject(`${response?.message || response?.detail}`);
            } catch {
              reject("Error occurred during upload.");
            }
          }
        }
      };

      xhr.onprogress = function (e) {
        if (e.lengthComputable) {
          onProgress && onProgress((e.loaded / e.total) * 100);
        }
      };
      onProgress && onProgress(0);

      xhr.open(
        "post",
        FILES_ENDPOINTS.upload + `${testMode ? `?test=${testMode.status}` : ""}`
      );
      xhr.setRequestHeader("authorization", `Bearer ${ActiveUser.getToken()}`);
      xhr.send(formData);
    });
  }

  async datahubUpload(body) {
    const { data } = await request({
      url: FILES_ENDPOINTS.datahub_upload,
      method: "POST",
      body,
    });
    return data;
  }

  //------------------------------------------------------------------------------

  async removeFile(query) {
    const { data } = await request({
      url: FILES_ENDPOINTS.delete,
      method: "DELETE",
      query,
    });
    return data;
  }

  async fetchAvailableFileTypes() {
    const { data } = await request({
      url: FILES_ENDPOINTS.availableFileTypes,
    });
    return data;
  }

  async fetchFiles() {
    const { data } = await request({
      url: FILES_ENDPOINTS.list,
    });
    return data;
  }
}

export const FilesService = new Files();
